/**
 * DGI homologación-simplificada status helpers for self-scratch onboarding.
 *
 * The tenant's `homologacionStatus` (from /tenants/current) is the raw
 * IngresoSimplificadoEntity status ladder: pending → portal_user_ready → … →
 * completed → vigente (or null when no request exists yet).
 */

/** Homologación is done — the RUC is an authorized emisor, the producción user
 *  is confirmed, and the self tenant can resume onboarding (certificate → CAE
 *  → finish).
 *
 *  `vigente` alone is NOT enough, and that is the whole point of the second
 *  argument. `vigente` is reached by the EmisorVigenciaCheck cron the moment
 *  DGI's padrón lists the RUC, which says only that DGI will accept their
 *  CFEs — it carries no information about the producción role on their
 *  e-Factura portal user, which is what lets Fiscalo read their data back
 *  (cfe-state-reconcile, reporte montos, CAE consulta, proveedor informe all
 *  live under /Produccion/). Three of ten tenants completed onboarding on
 *  padrón presence alone and we are blind on all three.
 *
 *  `produccionRoleRequired` is computed server-side in /tenants/current and is
 *  the SAME condition as the `produccion_role_unconfirmed` promotion gate —
 *  deliberately one boolean with one meaning, so the wizard and the backend
 *  cannot drift. It is already false for already-issuer tenants (no
 *  homologación row) and for accountant-run ones. See spec 9aca15e.
 */
export function isHomologacionComplete(
  status: string | null | undefined,
  produccionRoleRequired: boolean = false,
): boolean {
  if (produccionRoleRequired) return false;
  return status === "completed" || status === "vigente";
}

/** Homologación is in progress: a request exists but is not yet complete, so the
 *  self-scratch user is parked on the "homologación pendiente" screen. `null`
 *  means it has not started (the user is still on the create-e-Factura-user step). */
export function isHomologacionPending(
  status: string | null | undefined,
  produccionRoleRequired: boolean = false,
): boolean {
  return (
    status != null && !isHomologacionComplete(status, produccionRoleRequired)
  );
}
